<!-- Active product with: deviant driver as current regular driver -->
<wuc-display-field *ngIf="isActiveProduct && hasRegularDriver">
    <label>Regelmatige bestuurder</label>
    {{ regularDriverName }}
    <ng-container slot="action" *ngIf="canAddRegularDriver">
        <wuc-link [iconRight]="openedDriverForm ? 'arrow-up-bold' : 'arrow-down-bold'" iconSize="xs" type="secondary"
                  (clicked)="openedDriverFormChange.emit(!openedDriverForm)">{{ openedDriverForm ? 'Sluiten' : 'Wijzigen' }}</wuc-link>
    </ng-container>
</wuc-display-field>

<!-- Future or active product with: policy holder as current regular driver -->
<wuc-display-field *ngIf="(isActiveProduct || isFutureProduct) && isPolicyHolder">
    <label>Regelmatige bestuurder</label>
    Ikzelf
    <ng-container slot="action" *ngIf="isActiveProduct && canAddRegularDriver">
        <wuc-link [iconRight]="openedDriverForm ? 'arrow-up-bold' : 'arrow-down-bold'" iconSize="xs" type="secondary"
                  (clicked)="openedDriverFormChange.emit(!openedDriverForm)">{{ openedDriverForm ? 'Sluiten' : 'Wijzigen' }}</wuc-link>
    </ng-container>
</wuc-display-field>

<!-- Future product with: deviant driver as current regular driver -->
<wuc-display-field *ngIf="isFutureProduct && hasRegularDriverFuture">
    <label>Regelmatige bestuurder</label>
    {{ regularDriverFutureName }}
</wuc-display-field>
